import { render, staticRenderFns } from "./MontantiWeek.vue?vue&type=template&id=30401af0&scoped=true"
import script from "./MontantiWeek.vue?vue&type=script&lang=js"
export * from "./MontantiWeek.vue?vue&type=script&lang=js"
import style0 from "./MontantiWeek.vue?vue&type=style&index=0&id=30401af0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30401af0",
  null
  
)

export default component.exports